import { isObjectEmpty } from '@/utils/common.util';
import snakeCase from 'lodash/snakeCase';

export const fieldNameToSnakeCase = (fieldName: string): string => {
  return fieldName
    .split('__')
    .map((item) => snakeCase(item))
    .join('__');
};

const isFirstCharSortByPrefix = (field: string): boolean =>
  !!field.length && ['+', '-'].includes(field[0]);

const splitSoftByCriteria = (
  criteria: string
): { fieldName: string; prefix: string } => {
  const hasPrefix = isFirstCharSortByPrefix(criteria);
  const prefix = hasPrefix ? criteria[0] : '';
  const fieldName = hasPrefix ? criteria.slice(1) : criteria;

  return { fieldName, prefix };
};

export const sortByCriteriaToSnake = (criteria: string): string => {
  const { fieldName, prefix } = splitSoftByCriteria(criteria);

  return `${prefix}${fieldNameToSnakeCase(fieldName)}`;
};

export const parseSortByCriteria = (
  criteria?: string[] | null,
  fieldMapper?: Record<string, string[]> | null
): string | undefined => {
  if (!criteria || !criteria.length) return undefined;

  let sortBy = criteria;

  if (fieldMapper && !isObjectEmpty(fieldMapper)) {
    sortBy = sortBy.reduce<string[]>((previousValue, currentValue) => {
      const { fieldName, prefix } = splitSoftByCriteria(currentValue);

      const mappedFields = fieldMapper[fieldName];
      if (mappedFields != null) {
        return [
          ...previousValue,
          ...mappedFields.map((field) => `${prefix}${field}`)
        ];
      } else {
        return [...previousValue, currentValue];
      }
    }, []);
  }

  return sortBy.map((key) => sortByCriteriaToSnake(key)).join(',');
};

export const parseQueryParams = (
  params: Record<string, any>
): Record<string, any> => {
  return Object.keys(params).reduce(
    (res, fieldName) => ({
      ...res,
      [fieldNameToSnakeCase(fieldName)]: params[fieldName]
    }),
    {}
  );
};
